import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { app } from '../lib/firebase';
import { doc, getDoc, updateDoc, getFirestore } from 'firebase/firestore';

export const useStorage = () => {
  const storage = getStorage(app);
  const firestore = getFirestore(app);

  const uploadFile = async (file: File, path: string, documentType?: string): Promise<string> => {
    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);

    // If this is a document upload and document type is provided, update the document metadata in Firestore
    if (documentType && (path.includes('/documents/') || path.includes('/contracts/'))) {
      try {
        // Parse the path to determine collection and document ID
        // Paths are in the form: [collection]/[id]/documents/[filename]
        const pathParts = path.split('/');
        const collection = pathParts[0]; // "quotations" or "customers"
        const documentId = pathParts[1]; // The ID of the quotation or customer

        // For documents in the documents collection
        if (pathParts.length >= 4 && pathParts[2] === 'documents') {
          const docRef = doc(firestore, collection, documentId);
          const docSnapshot = await getDoc(docRef);
          
          if (docSnapshot.exists()) {
            // Get the current documents array
            const currentData = docSnapshot.data();
            const documents = currentData.documents || [];
            
            // Get filename for more precise matching
            const fileName = file.name;
            const baseName = fileName.substring(0, fileName.lastIndexOf('.')) || fileName;
            
            // Find the document with matching URL, name or originalName
            const documentIndex = documents.findIndex((doc: any) => 
              doc.url === downloadURL || 
              doc.name === fileName || 
              doc.originalName === fileName ||
              (doc.name && doc.name.includes(baseName)) ||
              (doc.originalName && doc.originalName.includes(baseName))
            );
            
            if (documentIndex >= 0) {
              // Update existing document type
              documents[documentIndex].type = documentType;
              await updateDoc(docRef, { documents });
              console.log(`Document type updated to ${documentType} for ${path}`);
            } else {
              // If document wasn't found by URL or name, it might be a new document
              // The parent component should handle adding it to the documents array
              console.log(`Document not found in Firestore, parent component should add it: ${path}`);
            }
          }
        }
      } catch (error) {
        console.error('Error updating document type in Firestore:', error);
      }
    }

    return downloadURL;
  };

  const deleteFile = async (path: string): Promise<void> => {
    const storageRef = ref(storage, path);
    await deleteObject(storageRef);
  };

  return { uploadFile, deleteFile };
}; 